import I18n from "^/config/i18n";

export default function ErrorBlock({ validation }) {
  if (!validation) {
    return null;
  }
  return (
    <span className="text-danger font-italic">
      {validation === "required" &&
        I18n.t("this field is required, please fill in")}
      {validation === "invalidFormat" &&
        I18n.t("format of email address is wrong, please correct it")}
    </span>
  );
}
